"use client";

import Link from "next/link";
import { useParams } from "next/navigation";
import Logo from "@/app/(components)/generics/Logo/Logo";
import { TKey } from "@/app/translations/TKey";
import { T } from "@/app/translations/Translations";
import { DEFAULT_LOCALE } from "@/app/vars/Languages";
import { Routes } from "@/app/vars/Routes";
import styles from "./NotFound.module.css";

export default function NotFound() {
  const params = useParams();
  const lang = (params?.lang as string) ?? DEFAULT_LOCALE;

  return (
    <div className={styles.container}>
      <div className={styles.logoWrapper}>
        <Logo />
      </div>

      <div className={styles.content}>
        <h1 className={styles.title}>{T(TKey.NOT_FOUND_TITLE, lang)}</h1>
        <p className={styles.text}>{T(TKey.NOT_FOUND_TEXT, lang)}</p>
        <Link href={Routes.ROOT(lang)} className={styles.action}>
          {T(TKey.NOT_FOUND_ACTION, lang)}
        </Link>
      </div>
    </div>
  );
}
